/**
 * Persona data for the interactive "Who Is EmoQ.ai For?" section
 * Each persona includes role information, examples, benefits, and sample content
 */

export const personaData = [
  { 
    icon: '📱', 
    role: 'Content Creator', 
    tagline: 'Go viral with data',
    description: 'Create content that resonates before you post',
    examples: [
      'Test Instagram captions for emotional impact before posting',
      'Compare two thumbnail images to see which drives more engagement',
      'Predict viral potential based on emotional triggers',
      'Optimize TikTok videos for maximum resonance',
      'Find the best posting time for your audience demographics'
    ],
    benefits: 'Save time, increase engagement by 30%, reduce guesswork',
    sampleContent: 'Just launched my new product! 🚀 After months of hard work, I\'m so excited to finally share this with you all. Click the link in bio to check it out!',
    sampleQuestion: 'Will this Instagram post drive engagement and shares? Which demographics will resonate most?'
  },
  { 
    icon: '🎯', 
    role: 'Marketer', 
    tagline: 'Test before launch',
    description: 'Validate campaigns before spending your budget',
    examples: [
      'Pre-test ad copy for emotional resonance across demographics',
      'A/B test landing page headlines for conversion optimization',
      'Validate email subject lines for open rate prediction',
      'Test campaign visuals for cultural sensitivity globally',
      'Measure brand messaging consistency across channels'
    ],
    benefits: 'Reduce wasted ad spend, improve ROI by 25%, faster campaign validation',
    sampleContent: 'Limited Time Offer: Get 50% off our premium plan! Join thousands of satisfied customers who have transformed their business. Don\'t miss out - offer ends soon!',
    sampleQuestion: 'How will this ad copy perform with millennials vs Gen Z? Will it create urgency without being pushy?'
  },
  { 
    icon: '📱', 
    role: 'Social Media Manager', 
    tagline: 'Platform perfection',
    description: 'Optimize posts for every platform',
    examples: [
      'Optimize posts for LinkedIn vs Instagram vs Twitter',
      'Schedule content based on audience emotional patterns',
      'Predict engagement before hitting publish',
      'Test multiple variations of the same message',
      'Analyze competitor content for emotional gaps'
    ],
    benefits: 'Higher engagement rates, consistent brand voice, data-driven posting',
    sampleContent: 'New blog post alert! 📝 Discover the top 5 strategies that helped us grow our audience by 200% in just 3 months. Link in comments!',
    sampleQuestion: 'Should I post this on LinkedIn or Instagram first? Which platform will give me the best engagement?'
  },
  { 
    icon: '✍️', 
    role: 'Copywriter', 
    tagline: 'Words that work',
    description: 'Write copy that converts',
    examples: [
      'Test headlines for emotional impact and click-through',
      'Validate tone and voice across different audiences',
      'Compare multiple copy variations instantly',
      'Ensure cultural appropriateness for global campaigns',
      'Optimize CTAs for conversion psychology'
    ],
    benefits: 'Write faster with confidence, improve conversion rates, eliminate guesswork',
    sampleContent: 'Transform Your Mornings: Wake up energized and ready to conquer the day with our scientifically-backed morning routine system.',
    sampleQuestion: 'Does this headline create curiosity and urgency? Which words trigger the strongest emotional response?'
  },
  { 
    icon: '🎨', 
    role: 'Designer', 
    tagline: 'Design with data',
    description: 'Validate design choices with emotion',
    examples: [
      'Test color schemes for emotional response',
      'Validate UI/UX designs for user sentiment',
      'Compare multiple design concepts objectively',
      'Ensure visual accessibility and inclusivity',
      'Test brand assets across different demographics'
    ],
    benefits: 'Design with confidence, reduce revision cycles, data-backed decisions',
    sampleContent: '[Imagine a product landing page hero image with bold typography and vibrant colors]',
    sampleQuestion: 'What emotions will users feel when they see this design? Is it professional yet approachable?'
  },
  { 
    icon: '💼', 
    role: 'Sales Team', 
    tagline: 'Pitches that close',
    description: 'Optimize presentations and pitches',
    examples: [
      'Test sales deck slides for emotional impact',
      'Validate pitch emails before sending to prospects',
      'Optimize proposal language for decision-makers',
      'A/B test outreach messages for response rates',
      'Ensure presentations resonate with target personas'
    ],
    benefits: 'Higher close rates, confident presentations, data-driven messaging',
    sampleContent: 'Hi Sarah, I noticed your company is expanding into new markets. Our platform helped companies like yours increase revenue by 40% in similar situations. Can we schedule a quick 15-minute call?',
    sampleQuestion: 'Will this cold email get a response? Does it sound helpful or too salesy?'
  },
  { 
    icon: '🚀', 
    role: 'Founder', 
    tagline: 'Validate faster',
    description: 'Test everything before you ship',
    examples: [
      'Test landing page copy before launch',
      'Validate investor pitch decks for emotional impact',
      'Optimize product descriptions for conversion',
      'Test pricing page messaging across segments',
      'Ensure brand messaging resonates with target market'
    ],
    benefits: 'Launch with confidence, save development time, data-driven product decisions',
    sampleContent: 'We\'re revolutionizing the way teams collaborate. Our AI-powered platform reduces meeting time by 50% while increasing productivity by 3x. Join the waitlist today!',
    sampleQuestion: 'Will investors find this pitch compelling? Does it create FOMO without sounding too good to be true?'
  },
  { 
    icon: '🎓', 
    role: 'Educator', 
    tagline: 'Engage learners',
    description: 'Create compelling learning content',
    examples: [
      'Test course materials for engagement potential',
      'Optimize presentation slides for student attention',
      'Validate educational content for emotional connection',
      'Compare different teaching approaches objectively',
      'Ensure inclusivity across diverse student backgrounds'
    ],
    benefits: 'Higher student engagement, better learning outcomes, inclusive content',
    sampleContent: 'Welcome to Week 5! This week we\'ll explore the fascinating world of neural networks. By the end of this module, you\'ll build your first AI model. Let\'s dive in!',
    sampleQuestion: 'Will students find this lesson intro motivating? Does it balance excitement with clarity?'
  }
];
